import { ITableCol } from "@data/interfaces/itable.interface";
import { ADMIN_STATUS_COLOR_ENUM, ADMIN_STATUS_ENUM } from "@modules/private/admin/data/enum/admin.enum";

export const ADMIN_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Activo' },
  { value: 'LOCKED', label: 'Bloqueado' }
]

export const ADMIN_COLUMNS: ITableCol[] = [
  { type: 'text', field: 'names', header: 'Nombre completo', showFilter: true },
  { type: 'text', field: 'email', header: 'Email', showFilter: true },
  { type: 'text', field: 'role.name', header: 'Role', showFilter: true },
  // Sin filtro a propósito: `usersService.findAll` no declara `isCommitteeMember` en sus
  // `mainFilters` y el FilterService descarta en silencio lo que no esté declarado.
  { type: 'boolean', field: 'isCommitteeMember', header: 'Comité', showFilter: false, dataType: 'boolean' },
  { type: 'enum', field: 'status', header: 'Estatus', showFilter: true, dataType: 'enum', enum: ADMIN_STATUS_ENUM, enumColor: ADMIN_STATUS_COLOR_ENUM, options: ADMIN_STATUS_OPTIONS },
  { type: 'date', field: 'createdAt', header: 'Fecha de creación', showFilter: true, dataType: 'date' },
]

export const ACTIONS = [
  { icon: 'fa-regular fa-pen-to-square', action: 'EDIT', title: 'Editar', color: 'primary' },
]